import { useEffect, useState } from "react"
import { BetInfoTypes } from "Types"

interface RESULT {
  text: string
  win: boolean
}

export const CheckWinner = (obj: BetInfoTypes, precision: number): RESULT => {
  const { win_seat, winAmount } = obj
  const [text, setText] = useState<string>("")
  const [win, setWin] = useState<boolean>(false)

  const winSeat = win_seat || ""
  useEffect(() => {
    if (winAmount && winAmount > 0) {
      // let num = winAmount?.toString()
      // const index = num.indexOf(".")
      // num = index >= 0 ? num?.slice(0, index + 3) : num
      setText(`${(+winAmount).toFixed(precision)}`)
      setWin(true)
    } else {
      setText("")
      setWin(false)
    }
  }, [winAmount, winSeat])

  return { text, win }
}
